import { render, staticRenderFns } from "./electronic-games-makers.vue?vue&type=template&id=2ed2b728&"
import script from "./electronic-games-makers.vue?vue&type=script&lang=js&"
export * from "./electronic-games-makers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports